<template>
  <div>
    <h1 class="text-center">Search Web POS Customer</h1>
    <List />
  </div>
</template>

<script>
import List from "@/views/POSCustomer/ListPosCustomer.vue";
export default {
  components: {
    List,
  },
};
</script>
